export const registerMicroFeed = (Alpine) => {
  Alpine.data('microFeed', () => ({
    query: '',
    cards: [],
    init() {
      this.cards = Array.from(this.$refs.list?.children || []);
      this.$watch('query', () => this.filterCards());
    },
    filterCards() {
      const keyword = this.query.trim().toLowerCase();
      this.cards.forEach((card) => {
        if (!keyword) {
          card.style.display = '';
          return;
        }
        const content = card.textContent?.toLowerCase() || '';
        card.style.display = content.includes(keyword) ? '' : 'none';
      });
    },
    async copyLink(url) {
      if (!navigator?.clipboard || !url) {
        return false;
      }
      try {
        await navigator.clipboard.writeText(url);
        return true;
      } catch (error) {
        console.error('Unable to copy micros link', error);
        return false;
      }
    },
  }));
};
